import IApplicationBase from "./IApplicationBase";
import IWorkflowStep from "../dto/IWorkflowStep";
import State from "../dto/StateEnum";
import StateReason from "../dto/StateReasonEnum";
import WorkflowCode from "../dto/WorkflowCodeEnum";

export default class ApplicationBase implements IApplicationBase {
    constructor(
        public id: string,
        public state: State,
        public stateReason: StateReason,
        public workflowSteps?: IWorkflowStep[]
    ) {}

    public get hasRedirectWorkflowCode(): boolean {
        return !!this.getWorkflowStepWithCode(WorkflowCode.REDIRECT);
    }

    private getWorkflowStepWithCode(code: WorkflowCode): IWorkflowStep | undefined {
        return this.workflowSteps
            ? this.workflowSteps!.filter((step: IWorkflowStep) => step.code === code).shift()
            : undefined;
    }

    public get gatewayRedirectUrl(): string {
        const redirectStep: IWorkflowStep | undefined = this.getWorkflowStepWithCode(WorkflowCode.REDIRECT);

        return !!redirectStep && redirectStep.redirect ? redirectStep.redirect.gatewayRedirectUrl : "";
    }
}
